module.exports = __webpack_public_path__ + "img/full6-min.fbbae371.png";